import Model from 'core/model/Model';
import $auth from 'app/stores/$auth';
import { MITIGATION_TYPES } from '@kentik/ui-shared/mitigations/constants';
import { afTemplateInfersIpCidr } from 'app/stores/mitigations/mitigationsUtils';

const DUMMY_IP = '127.42.42.42';

class ManualMitigation extends Model {
  constructor({ $mitigations, ...attributes }) {
    super(attributes);
    this.$mitigations = $mitigations;
  }

  get urlRoot() {
    return '/api/ui/mitigations/manual-mitigate';
  }

  get defaults() {
    return {
      pairingID: null,
      action: 'start_mitigation',
      alertKey: '',
      comment: '',
      autoStopTTL: 0
    };
  }

  getManualMitigationData = (data) => {
    const [platformID, methodID] = data.pairingID.split('-');
    const platformMethod = this.$mitigations.platformsCollection.getPlatformMethod({ platformID, methodID });

    if (!platformMethod) {
      return {};
    }

    const { method } = platformMethod || {};
    let shouldUseDummyIp = false;

    if (method.type === MITIGATION_TYPES.FLOWSPEC) {
      shouldUseDummyIp = !method.details?.destIpCidr?.infer && !method.details?.sourceIpCidr?.infer;
    } else if (method.type === MITIGATION_TYPES.ADAPTIVE_FLOWSPEC) {
      const afTemplate = method.get(MITIGATION_TYPES.ADAPTIVE_FLOWSPEC)?.template || {};
      shouldUseDummyIp = !afTemplateInfersIpCidr(afTemplate);
    }

    const adjustedData = {
      platformID,
      methodID
    };

    if (shouldUseDummyIp) {
      adjustedData.alertKey = DUMMY_IP;
    }

    return adjustedData;
  };

  // This only fires when saving via form submission
  serialize(data) {
    const { uiProperties } = data || {};
    const { autoStopValue, autoStopFactor } = uiProperties || {};

    const dataToSerialize = {
      action: data.action,
      srcPort: data.srcPort,
      dstPort: data.dstPort,
      alertKey: data.alertKey,
      comment: `[${$auth.activeUser.user_name} manually started] ${data.comment}`,
      autoStopTTL: Number(autoStopValue) * Number(autoStopFactor), // in minutes
      ...this.getManualMitigationData(data)
    };

    if (data.tenantID) {
      dataToSerialize.applicationMetadata = {
        type: 'subtenant',
        tenantID: data.tenantID
      };
    }

    return super.serialize(dataToSerialize);
  }
}

export default ManualMitigation;
